<template>
  <v-layout
    column
    align-center
  >
    <v-dialog
      v-model="dialog"
      max-width="400px"
    >
      <v-card>
        <v-toolbar
          dark
          color="error"
          dense
          flat
        >
          <v-spacer />
          <v-toolbar-title
            class="white--text"
          >
            Confirm this action
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text
          v-show="!!message"
          class="text-center"
        >
          {{ message }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="error"
            class="justify-center"
            @click="agree"
          >
            Yes, I'm sure
          </v-btn>
          <v-btn
            text
            color="primary darken-1"
            @click="cancel"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ConfimDeleteComponent',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
  }),
  methods: {
    open(name) {
      this.dialog = true;
      this.message = `Are you sure you want to delete ${name}?`;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
